import get from 'lodash/get';
import * as types from './constants';
const defaultState = {
  loading: false,
  error: null,
  activeStep: 0,
  application: {},
  paymentPlanType: '',
  instalmentPlanList: [],
  buyers: [],
  broker: {},
  brokerDetails: {},
  contractDetails: {},
  representativeDetails: [],
  documents: [],
  property: {},
  breakdown: {},
  sellerDetails: {},
  companiesResponse: {},
  usersResponse: {},
  currentBuyerDocuments: [],
  // --------------- previous work ------------- //
  applicationInitalData: {},
  totalSellingPercentage: 0,
  totalBuyingPercentage: 0,
  applicationId: null,
  applicationType: '',
  propertyDocuments: null,
  updatePercentbuyer: [],
  propertyDetails: null,
};

// eslint-disable-next-line consistent-return
export default function legalNoticeCreationReducer(state = defaultState, action = {}) {
  switch (action.type) {
    case types.LEGAL_NOTICE_LOADING:
      return {
        ...state,
        loading: true,
      };
    case types.LEGAL_NOTICE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case types.LEGAL_NOTICE_ERROR:
      return {
        ...state,
        loading: false,
        error: get(action, 'payload', null),
      };
    case types.LEGAL_NOTICE_CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };
    case types.LEGAL_NOTICE_CLEAR_APPLICATION:
      return {
        ...defaultState,
      };

    case types.LEGAL_NOTICE_FETCH_PROPERTY_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        property: get(action.payload, 'property', {}),
      };

    case types.LEGAL_NOTICE_FETCH_CONTRACT_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        contractDetails: get(action.payload, 'contractDetails', {}),
      };

    case types.LEGAL_NOTICE_FETCH_APPLICATION_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        contractDetails: null,
        application: get(action.payload, 'application', {}),
      };

    case types.LEGAL_NOTICE_DELETE_BROKER_SUCCESS: {
      return {
        ...state,
        loading: false,
        broker: {},
      };
    }

    case types.LEGAL_NOTICE_ADD_BUYER_SUCCESS: {
      return {
        ...state,
        loading: false,
        documents: get(action.payload, 'documents', state.documents),
      };
    }

    case types.LEGAL_NOTICE_SAVE_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case types.LEGAL_NOTICE_CHANGE_WORKFLOW_STEP:
      return {
        ...state,
        activeStep: get(action.payload, 'step'),
      };
    case types.LEGAL_NOTICE_FETCH_DOCUMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        documents: get(action.payload, 'documents', []),
      };

    case types.LEGAL_NOTICE_FIELD_CHANGE:
      if (action.payload) {
        return {
          ...state,
          application: {
            ...state.application,
            ...action.payload.data,
          },
        };
      }
      break;
    case types.LEGAL_NOTICE_FORM_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
}
